import React, { useState, useRef, useEffect } from 'react';
import '../../../../styles/profile/components/add-link-modal.css';

interface AddLinkModalProps {
  open: boolean;
  onClose: () => void;
  onAdd: (data: LinkData) => void;
  title?: string;
  initialData?: LinkData;
  isEditMode?: boolean;
}

interface LinkData {
  title: string;
  url: string;
  description: string;
}

export default function AddLinkModal({ 
  open, 
  onClose, 
  onAdd,
  title: modalTitle = "Add Link",
  initialData,
  isEditMode = false
}: AddLinkModalProps) {
  const [title, setTitle] = useState('');
  const [url, setUrl] = useState('');
  const [description, setDescription] = useState('');
  
  const overlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (open && initialData) {
      setTitle(initialData.title);
      setUrl(initialData.url);
      setDescription(initialData.description || '');
    }
  }, [open, initialData]);

  useEffect(() => {
    if (!open) {
      setTitle('');
      setUrl('');
      setDescription('');
    }
  }, [open]);

  const handleSubmit = () => {
    if (!title.trim() || !url.trim()) {
      alert('Please fill in required fields');
      return;
    }

    onAdd({
      title,
      url,
      description,
    });
  };

  if (!open) return null;

  return (
    <div
      className="add-link-modal-overlay"
      ref={overlayRef}
      onMouseDown={(e) => {
        if (e.target === overlayRef.current) onClose();
      }}
    >
      <div className="add-link-modal">
        <div className="add-link-modal-header">
          <h2 className="add-link-modal-title" style={{ textAlign: 'left' }}>{modalTitle}</h2>
        </div>

        <div className="add-link-modal-body">
          <div className="add-link-modal-field">
            <label className="add-link-modal-label">
              Title
              <span className="add-link-modal-required">Required</span>
            </label>
            <input
              type="text"
              className="add-link-modal-input"
              placeholder="i.e. My personal site"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>

          <div className="add-link-modal-field">
            <label className="add-link-modal-label">
              URL
              <span className="add-link-modal-required">Required</span>
            </label>
            <input
              type="text"
              className="add-link-modal-input"
              placeholder="i.e. myportfolio.com"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
            />
          </div>

          <div className="add-link-modal-field">
            <label className="add-link-modal-label">Description</label>
            <textarea
              className="add-link-modal-textarea"
              placeholder="Describe this link"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
        </div>

        <div className="add-link-modal-footer">
          <button
            type="button"
            className="add-link-modal-btn add-link-modal-btn--discard"
            onClick={onClose}
          >
            Discard
          </button>
          <button
            type="button"
            className="add-link-modal-btn add-link-modal-btn--add"
            onClick={handleSubmit}
          >
            {isEditMode ? 'Update' : 'Add'}
          </button>
        </div>
      </div>
    </div>
  );
}

